export function getNowToDisableDateForAdafModals() {
  const now = new Date();
  now.setDate(1);
  now.setHours(0, 0, 0, 0);
  return now;
}

export default {
  methods: {
  /**
   * Get the disabledDates for the datepicker
   *
   * This mixin is used on "Prolonger le contrat" | "Déclarer un préavis" modals
   * to disable dates in the past
   *
   * @return {from: (Date), to: (Date)}}
   */
    getNowToDisableDateForAdafModals,
  },
};
